module.exports = __webpack_public_path__ + "img/card5.1e255fd4.png";